import { FaIcon } from '@/lib/fa';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import * as React from 'react';

type CommonProps = {
  dataTestId?: string;
  title?: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
};

type IconsProps = (
  {
    LeadingIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    leadingIcon?: undefined;
    faLeadingIcon?: undefined;
  } | {
    LeadingIcon?: undefined;
    leadingIcon?: React.ReactNode;
    faLeadingIcon?: undefined;
  } | {
    LeadingIcon?: undefined;
    leadingIcon?: undefined;
    faLeadingIcon?: IconDefinition;
  } | {
    LeadingIcon?: undefined;
    leadingIcon?: undefined;
    faLeadingIcon?: undefined;
  }
)

type SettingsSectionProps = CommonProps & IconsProps;

export const SettingsSection = ({ actions, title, children, faLeadingIcon, leadingIcon, LeadingIcon, dataTestId } : SettingsSectionProps) => {
  return (
    <section className="tw-mb-10 tw-shadow-sm tw-bg-white" data-test-id={dataTestId}>
      {title || faLeadingIcon || leadingIcon ? (
        <header className="tw-p-4 tw-flex tw-items-center tw-space-x-3 tw-content-justiy">
          <div className='tw-flex tw-items-center tw-space-x-3 '>
            {LeadingIcon && <LeadingIcon className="tw-h-6 tw-w-6 tw-text-gray-500 tw-text-content-secondary" />}
            {faLeadingIcon && <FaIcon icon={faLeadingIcon} className="tw-h-6 tw-w-6 tw-text-gray-500 tw-text-content-secondary" />}
            {leadingIcon && leadingIcon}
            <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">{title}</h2>
          </div>
          {actions && (<div className='tw-flex tw-flex-1 tw-flex tw-justify-end tw-gap-2'>{actions}</div>)}
        </header>
      ) : null}
      {children && <div className="tw-space-y-5">{children}</div>}
    </section>
  );
};
